// A click on a popup's dark backdrop closes it, as its X does, for every
// popup of the site at once: PopUpModal and the one-off popups all draw the
// backdrop as .newPopUpModalWrap and their X as .newPopUpModalCloseIcon, so
// one listener clicks that X for them (whatever the X does, guards included:
// AddFundsPopUp's ignores it while paying).
//   - Only a click that starts and ends on the backdrop itself: selecting
//     text in the box and letting go outside doesn't close it.
//   - Popups with no X stay open (they mean to: a decision has to be made).
//   - data-keep-open on the backdrop opts out (files uploading).
// Installed once, from index.js.

let installed = false;

export const installBackdropClose = () => {
  if (installed || typeof document === "undefined") return;
  installed = true;
  let downOn = null;
  document.addEventListener("mousedown", (e) => {
    const t = e.target;
    downOn = t && t.classList && t.classList.contains("newPopUpModalWrap") ? t : null;
  }, true);
  document.addEventListener("click", (e) => {
    const wrap = downOn;
    downOn = null;
    if (!wrap || e.target !== wrap || !wrap.isConnected || wrap.hasAttribute("data-keep-open")) return;
    // Its own X, not one of a popup inside it.
    const close = Array.from(wrap.querySelectorAll(".newPopUpModalCloseIcon"))
      .find((x) => x.closest(".newPopUpModalWrap") === wrap);
    if (!close) return;
    close.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
  });
};
